export default __webpack_public_path__ + "static/thankyou-acded1032378f8a20a649a603497b4fa.jpg";